<div class="confirm-status">
  <div class="text-center mt-4">
    <h5 class="title">Confirmar número Whatsapp</h5>
    <label class="mt-1">Asegurese de que el código de area sea correcto y tambien el número del cliente</label>
    <mat-form-field class="full-width-input" appearance="outline">
      <mat-label class="text-field">Teléfono</mat-label>
      <input matInput [(ngModel)]="phone" type="text"
        name="phone" autocomplete="off" required #phoneC="ngModel"
        pattern="^(\+591)?[6-7]([0-9]{7,14})$">
      <mat-error class="mt-1" *ngIf="phoneC.errors?.required">
        {{validationMessages.phone.required}}
      </mat-error>
    </mat-form-field>
    <div class="row mt-2">
      <div class="col-6">
        <button class="btn btn-primary w-75" (click)="accept()">Aceptar</button>
      </div>
      <div class="col-6">
        <button class="btn btn-secondary w-75" mat-dialog-close>Cancelar</button>
      </div>
    </div>
  </div>
</div>